import { roadMapBridge } from '../render/roadMapBridge';

// HEARING A SOURCE IN THE STREET — shared by the plaza stage (components/city/
// CityStage) and the street's other music (components/city/CitySounds), so the
// two carry the same way and a wall muffles them the same.

/** Is there a building on the line from the listener to the source? (road map class 3), the last `skipEnd` units — the source's own frontage — excepted. */
export function walled(ax, az, bx, bz, skipEnd = 3) {
  const m = roadMapBridge.map;
  if (!m?.cls) return false;
  const u = m.unitsPerTexel || m.rect.w / m.w;
  const L = Math.hypot(bx - ax, bz - az);
  for (let s = 0.5; s < L - skipEnd; s += 0.4) {
    const i = Math.floor((ax + ((bx - ax) * s) / L - m.rect.minX) / u);
    const r = Math.floor((az + ((bz - az) * s) / L - m.rect.minZ) / u);
    if (i < 0 || r < 0 || i >= m.w || r >= m.h) continue;
    if (m.cls[r * m.w + i] === 3) return true;
  }
  return false;
}

/** Loud up to `full` units, gone at `far`, falling off like a PA in between. */
export function falloff(d, full, far, peak = 0.85) {
  if (d <= full) return peak;
  if (d >= far) return 0;
  const k = (d - full) / (far - full);
  return peak * Math.pow(1 - k, 1.6);
}

// iOS ignores `volume` on media elements: out of earshot is MUTED (CityTalk).
export function setLevel(el, v) {
  const x = Math.max(0, Math.min(1, v));
  el.volume = x;
  const mute = x < 0.03;
  if (el.muted !== mute) el.muted = mute;
}
